import 'whatwg-fetch';
import get from 'lodash/get';
import { toast } from 'react-toastify';

import errors from '../config/errorCodes';

const API_URL = process.env.REACT_APP_API_URL;

const getRouteWithParams = (route, params) => {
  const tmp = Object.keys(params).map((key) => `${key}=${
    Array.isArray(params[key]) ? params[key].join(`&${key}=`) : params[key]}`);

  return `${route}?${tmp.join('&')}`;
};

const handle401 = () => {
  toast.error('Brak uprawnień do zasobu');
  return Promise.reject();
};

class Api {
  constructor() {
    this.headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    };
    this.baseUrl = API_URL;
  }

  setToken(token) {
    this.token = token;
  }

  get(route, params, type) {
    let newRoute = route;
    if (params) {
      newRoute = getRouteWithParams(route, params);
    }
    return this.xhr(newRoute, null, 'GET', this.headers, type);
  }

  put(route, params) {
    return this.xhr(route, params, 'PUT');
  }

  post(route, params, routeParams, headers, type) {
    let newRoute = route;
    if (routeParams) {
      newRoute = getRouteWithParams(route, routeParams);
    }
    return this.xhr(newRoute, params, 'POST', headers, type);
  }

  delete(route, params) {
    return this.xhr(route, params, 'DELETE');
  }

  async xhr(route, params, method, headers = this.headers, type = 'json') {
    const url = `${this.baseUrl}${route}`;
    const options = {
      method,
      headers,
    };

    if (params) {
      if (params instanceof FormData) {
        options.body = params;
        options.headers = undefined;
      } else {
        options.body = JSON.stringify(params);
      }
    }

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${this.token}`,
    };

    return fetch(url, options)
      .then((response) => {
        switch (response.status) {
          case 200:
          case 201:
            return response[type]();
          case 400:
          case 403:
          case 422:
            return response[type]().then((data) => {
              const errorCode = get(data, 'code', 0);
              const error = get(errors, errorCode, 'Ups błąd. Pracujemy nad nim.');

              toast.error(error);
              return Promise.reject(data);
            });
          case 409:
            return response[type]().then((data) => {
              toast.error('Rekord zawiera powiązania do innych rekordów. Usuń je najpierw.');
              return Promise.reject(data);
            });
          case 404:
          case 500: {
            return response[type]().then((data) => {
              toast.error('Ups błąd. Pracujemy nad nim.');
              return Promise.reject(data);
            });
          }
          case 401: {
            return handle401();
          }
          default:
            return Promise.reject(new Error('Something went wrong'));
        }
      }).catch((e) => Promise.reject(e));
  }
}

export default new Api();
